(() => {
  if (window.FlecttoCartUpsellLoaded) return;
  window.FlecttoCartUpsellLoaded = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-flectto-add-variant]');
    if (!button || button.disabled) return;

    event.preventDefault();

    const variantId = Number(button.dataset.flecttoAddVariant);
    const text = button.querySelector('.flectto-cart-upsell__button-text');
    const loading = button.querySelector('.flectto-cart-upsell__button-loading');
    const cartDrawer = document.querySelector('cart-drawer');

    if (!Number.isInteger(variantId) || variantId <= 0) {
      console.error('Flectto upsell: Geçersiz varyant kimliği.', button.dataset.flecttoAddVariant);
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (text) text.hidden = true;
    if (loading) loading.hidden = false;

    try {
      const sections = ['cart-drawer', 'cart-icon-bubble'];
      const root = window.Shopify?.routes?.root || '/';
      const addUrl = `${root}cart/add.js`.replace(/\/+/g, '/');

      const response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections,
          sections_url: window.location.pathname,
        }),
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Ürün sepete eklenemedi.');
      }

      if (cartDrawer?.renderContents && data.sections) {
        data.id = variantId;
        cartDrawer.renderContents(data);
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error('Flectto upsell error:', error);
      button.disabled = false;
      button.removeAttribute('aria-busy');

      if (text) {
        text.hidden = false;
        text.textContent = 'Tekrar dene';
      }
      if (loading) loading.hidden = true;
    }
  });
})();
